export const menuSections = () => {
	return {
		inicio: {
			id: 'inicio',
			name: 'Início',
			href: '/',
		},
		comoFunciona: {
			id: 'como-funciona',
			name: 'Como funciona',
			href: '?section=como-funciona',
		},
		convites: {
			id: 'convites',
			name: 'Convites',
			href: '?section=convites',
		},
		sobreNos: {
			id: 'sobre-nos',
			name: 'Sobre nós',
			href: '?section=sobre-nos',
		},
		perguntasFrequentes: {
			id: 'faq',
			name: 'Perguntas Frequentes',
			href: '/faq',
		},
		faleComAgente: {
			id: 'fale-conosco',
			name: 'Fale conosco',
			href: '/contato',
		},
	}
}

export const userSections = () => {
	return {
		inicio: {
			id: 'inicio',
			name: 'Início',
			href: '/',
		},
		comoFunciona: {
			id: 'resgatar-valores',
			name: 'Resgatar valores',
			href: '/minha-area/resgatar-valores',
		},
		convites: {
			id: 'ver-meu-convite',
			name: 'Ver meu convite',
			href: '/minha-area/convite',
		},
		sobreNos: {
			id: 'editar-meu-perfil',
			name: 'Editar meu perfil',
			href: '/minha-area/editar-perfil',
		},
		editarDadosBancarios: {
			id: 'editar-dados-bancarios',
			name: 'Editar dados bancários',
			href: '/minha-area/dados-bancarios',
		},
		listaConvidados: {
			id: 'lista-de-convidados',
			name: 'Lista de convidados',
			href: '/minha-area/convidados',
		},
		mensagensRecebidas: {
			id: 'mensagens-recebidas',
			name: 'Mensagens recebidas',
			href: '/minha-area/mensagens-recebidas',
		},
		faleComAgente: {
			id: 'fale-com-agente',
			name: 'Fale com agente',
			href: '/minha-area/fale-com-a-gente',
		},
		perguntasFrequentes: {
			id: 'perguntas-frequentes',
			name: 'Perguntas frequentes',
			href: '/faq',
		},
	}
}
